import React from 'react';
import ConfirmModal from "./ConfirmModal/ConfirmModal";
import TemplateModal from "./TemplateModal/TemplateModal";
import CanvasItemConfigModal from "./CanvasItemConfigModal/CanvasItemConfigModal";
import CreatePaletModal from "./Palet/CreateModal/CreateModal";
import UpdatePaletModal from "./Palet/UpdateModal/UpdateModal";
import ProjectModal from "./ProjectModal/ProjectModal";

const Modals = () => {

  return (
    <div
      style={{
        zIndex: 101
      }}
    >
      <ConfirmModal />
      <TemplateModal />
      <CreatePaletModal />
      <UpdatePaletModal />
      <CanvasItemConfigModal />
      <ProjectModal />
    </div>
  );
};

export default Modals;
